import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_SNAPSHOT_REQUEST = "GET_SNAPSHOT_REQUEST";
export const GET_SNAPSHOT_SUCCESS = "GET_SNAPSHOT_SUCCESS";
export const GET_SNAPSHOT_ERROR = "GET_SNAPSHOT_ERROR";

//* ACTIONS ------------------------------------------------
export const getSnapshotRequest = (payload = {}, callback) => ({
  type: GET_SNAPSHOT_REQUEST,
  payload,
  callback,
});

export const getSnapshotSuccess = (data) => ({
  type: GET_SNAPSHOT_SUCCESS,
  payload: data,
});

export const getSnapshotError = (error) => ({
  type: GET_SNAPSHOT_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getSnapshotServiceRequest = async ({ periodId, ...params }) => {
  const options = await withToken({
    method: Methods.GET,
    params,
    headers: { CompanyId: await getUserCompany() },
  });

  return request(`/payrolls/periods/${periodId}/snapshot`, options);
};
